var PROD_API_URL = process.env.REACT_APP_PROD_API_URL;
export const getAnalysisReport = async (
  authAttributes: any,
  export_job_id: string
): Promise<any> => {
  const response = await fetch(
    `${PROD_API_URL}/v3/admin/export_jobs/${export_job_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token token="${authAttributes?.token}", email="${authAttributes?.email}"`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch analysis report for ${export_job_id}`);
  }

  const data = await response.json();
  return data;
};

export const patchBrandMetadata = async (
  authAttributes: any,
  brand_id: string,
  metadata: any
): Promise<any> => {
  const response = await fetch(`${PROD_API_URL}/v3/admin/brands/${brand_id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token token="${authAttributes?.token}", email="${authAttributes?.email}"`,
    },
    body: JSON.stringify(metadata),
  });

  if (!response.ok) {
    throw new Error(`Failed to update brand metadata for ${brand_id}`);
  }

  const data = await response.json();
  return data;
};
